import React from 'react';
import SeoHead from '@//components/head/SeoHead';
import HeroComponent from '@/components/UI/Hero';
import { AboutContent } from '@/components/sections/AboutContent';
import AboutHero from '@/components/sections/AboutHero';
import { usePageEntrance } from '@/hooks/usePageEntrance';
import styles from '@/styles/Home.module.css';
import type { NextPage } from 'next';

const About: NextPage = () => {
  usePageEntrance();
  return (
    <>
      <SeoHead
        title={'OverpassIP'}
        description={`Most people don’t have the resources, time, or connections to truly use
        their web3 IP. Our goal at OverpassIP is to provide holders with easily
        accessible opportunities to leverage their NFT’s IP. With OverpassIP,
        the Web3 user will seamlessly connect with the Web2 brand. Join us in
        revolutionizing IP functionality for years to come.`}
      />
      <main className={styles.main}>
        <HeroComponent heroSection={<AboutHero />} content={<AboutContent />} />
      </main>
    </>
  );
};

export default About;
